import React, { useState } from 'react';

// INTERFACES
import { ITextAreaProps } from 'interfaces/TextArea.interface';

// STYLES
import { ModalTextMessage } from './styles';

const Modal: React.FC<ITextAreaProps> = ({
  titleTextArea,
  message,
  rows = 5,
  name = 'message',
  placeholder = 'Mensagem'
}: ITextAreaProps) => {
  const [messageState, setMessageState] = useState<string>('');

  const handleMessage = (messageField) => {
    setMessageState(messageField);
    message(messageField);
  };

  return (
    <ModalTextMessage>
      {titleTextArea}
      <textarea
        name={name}
        rows={rows}
        placeholder={placeholder}
        value={messageState}
        onChange={(event) => handleMessage(event.target.value)}
      >
        {messageState}
      </textarea>
    </ModalTextMessage>
  );
};

export default Modal;
